import APIService from '@/services/APIService.js';

export default {
  getAllAnalisesBp(includeExpiredRecords) {
    return APIService.apiCall().get(`/AnalisesBancoPrecos/getAllAnalises/${includeExpiredRecords}`);
  },
  getAnaliseBP(id) {
    return APIService.apiCall().get(`/AnalisesBancoPrecos/getAnaliseBP/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/AnalisesBancoPrecos/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/AnalisesBancoPrecos/executar/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/AnalisesBancoPrecos/salvar/${postData.id}`, JSON.stringify(postData));
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/AnalisesBancoPrecos/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  }
};
